import React, { useState } from 'react';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const Notification = ({
  notificationsVisible,
  handleToggleNotifications,
}: any) => {
  const { notificationMessages } = useTokenContext();
  const [messagesVisible, setMessagesVisible] = useState(true);

  const handleToggleMessages = () => {
    setMessagesVisible(!messagesVisible);
  };

  return notificationsVisible ? (
    <div
      className="absolute left z-10 mt-72 flex w-screen max-w-max -translate-x-1/2"
      style={{
        backgroundColor: 'var(--neutral-40)',
      }}
    >
      <div
        className="notification-arrow"
        style={{
          width: 0,
          height: 0,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderBottom: '10px solid var(--neutral-40)',
          position: 'absolute',
          top: '-10px',
          right: '50px',
        }}
      />
      <div className="w-screen max-w-md flex-auto overflow-hidden text-sm leading-6 shadow-lg ring-2 	ring-neutral-40 bg-gradient-to-r from-neutral-20 to-primary-50">
        <div>
          {JSON.parse(notificationMessages) &&
          JSON.parse(notificationMessages).length > 0 ? (
            <div
              id="messages"
              style={{ display: messagesVisible ? 'block' : 'none' }}
            >
              {JSON.parse(notificationMessages).map((item) => {
                const isSuccess = item.status === 'success';
                const isError = item.status === 'error';

                return (
                  <div
                    key={item?.id}
                    className={`group relative flex gap-x-lg p-md ${
                      isSuccess ? 'border-success-500 bg-success-50' : ''
                    } ${isError ? 'border-danger-500 bg-danger-50' : ''}`}
                    style={{
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      borderRadius: '10px',
                      margin: '10px',
                    }}
                  >
                    <div
                      className={`mt-xs flex h-11 w-11 flex-none items-center justify-center group-hover:bg-neutral-10 ${
                        isSuccess ? 'bg-success-100' : ''
                      } ${isError ? 'bg-danger-100' : ''}`}
                    >
                      {isSuccess ? (
                        <CheckCircleOutlined className="text-success-500" />
                      ) : (
                        <CloseCircleOutlined className="text-danger-500" />
                      )}
                    </div>
                    <div>
                      <a href="#" className="font-semibold text-neutral-900">
                        {item?.title}{' '}
                        <span className="text-xs text-neutral-100 animate-pulse">
                          {item?.timestamp}
                        </span>
                        <span className="absolute inset-0" />
                      </a>
                      <p className="mt-xs text-neutral-400">{item?.message}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          <div className="grid grid-cols-2 divide-x divide-neutral-40 bg-neutral-30">
            <button
              className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-neutral-900 hover:bg-primary-50"
              onClick={handleToggleMessages}
            >
              <i className="fa-solid fa-broom" />{' '}
              {messagesVisible ? 'Clear' : 'Undo'}
            </button>
            <button
              className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-neutral-900 hover:bg-primary-50"
              onClick={handleToggleNotifications}
            >
              <i className="fa-regular fa-circle-xmark" />{' '}
              {notificationsVisible ? 'Close' : 'Show Notifications'}
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Notification;
